import { FieldValidation } from '@atlassian/mpac-utils';
export const checkSupportUrl = name => url => {
  if (!FieldValidation.checkNonEmptyString(name)(url)) {
    return FieldValidation.checkValidHttpUrl(name)(url);
  }
};
export const checkSupportMode = (supportUrl, supportEmail, supportPhone) => {
  if (!(supportEmail || supportUrl || supportPhone)) {
    return {
      supportUrl: 'Provide atleast one mode of support',
      supportEmail: 'Provide atleast one mode of support',
      supportPhone: 'Provide atleast one mode of support'
    };
  }
};